import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiLogin, apiMe, getToken, setToken } from "./api";

const Ctx = createContext({
  user: null,
  loading: true,
  login: async () => { throw new Error("no provider"); },
  logout: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = getToken();
      if (token) {
        try {
          const me = await apiMe();
          setUser(me);
        } catch {
          setToken(null);
        }
      }
      setLoading(false);
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const { user } = await apiLogin(email.trim().toLowerCase(), password);
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(async () => {
    setToken(null);
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, loading, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
